import {TradeInstructionsComponent} from "@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.component";
import {
  expTypes,
  orderTypes
} from "@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.model";

export function orderTypeLayoutSetup(expirationBoolean: boolean, self:TradeInstructionsComponent) {
  const item = self.data;
  const orderType = self.orderTypeSelected ? self.orderTypeSelected.id : '';
  const orderTypePlaceHolder = self.orderTypePlaceHolder ? self.orderTypePlaceHolder.id : '';
  const ordIsNotHeld = self.notHeld;
  const isOrderQuantityWhole = Number.isInteger(Number(self.data?.quantity));
  const shouldHideMoc = !isOrderQuantityWhole;
  const shouldHideFractionalLimitExpTypes = orderType == 'LIMIT' && !isOrderQuantityWhole;
  const getExpTypesByOrderType = (queryValue: string) => {
    const selectedExpTypes = self.getFilteredArray(expTypes, 'orderType', queryValue);
    return self.getAvailableExpirationTypes(selectedExpTypes, shouldHideMoc, shouldHideFractionalLimitExpTypes);
  }
  const setPreferredExpirationType = (availableExpTypes: any[] = self.expTypes, preferredExpTypeId = 'DAY') => {
    const preferredExpType = self.getDefaultExpirationType(availableExpTypes, preferredExpTypeId);
    self.expTypeSelected = preferredExpType;
    if (preferredExpType) {
      if (self.expirationType !== preferredExpType.id) {
        self.expirationTypeChanged({value: {id: preferredExpType.id}});
      }
    } else {
      self.expirationType = null;
    }
  };
  let notHeldDestination = '';
  if (self.notHeldDestinationSelected) {
    notHeldDestination = self.notHeldDestinationSelected.id || '';
  }
  const checkBlockDeskBool = (ordIsNotHeld && notHeldDestination == "AOM_PRINTER");

  self.priceTypeRadioDisplayHide(orderType, "orderddfun"); // hide radio buttons by default if order type is not Limit
  if (expirationBoolean) {
    if (self.data.variousFields && self.data.variousFields.indexOf('expirationType') > -1) {
      self.expTypeSelected = null;
      self.expirationType = null;
    } else {
      if (self.expirationType) {
       setPreferredExpirationType(self.getAvailableExpirationTypes(expTypes), 'DAY');
      }
    }
  }
  //IREBALUX-354 changes
  if (self.actionType == "MultiEdit" && orderType == "") {
    self.priceDisabled = true;
    self.expirationTypeDisabled = true;
  }

  if (orderType == "MARKET") {
    // dijit.byId("price").setDisplayedValue("M"); // done in template
    self.priceDisabled = true;
    self.expirationDateDisabled = true;
    self.expirationDate = null;

    self.optionOrderTypeVisible = false;
    self.optionOrderTypeDisabled = true;

    const queryValue = checkBlockDeskBool ? "mBLOCKDESK" : "MARKET";

    if (ordIsNotHeld) {

      self.expirationTypeDisabled = true;
    }
    if (expirationBoolean != undefined && expirationBoolean) {
      if (self.data.variousFields && self.data.variousFields.indexOf('expirationType') > -1) {
        self.expTypeSelected = null;
        self.expirationType = null;
      } else {
        if (self.expirationType) {
          setPreferredExpirationType(self.expTypes, 'DAY');
        }
      }
    }

    if (!self.changeOrderType) {
      self.expirationTypeDisabled = true;
    }

    self.expTypes = getExpTypesByOrderType(queryValue);

    self.priceVisible = true;
    self.limitPriceVisible = false;
    self.stopPriceVisible = false;
    //IREBALUX-1857 // sa - disables radios
    // dijit.byId("limitPriceTypeNone").set("disabled", true);
    // dijit.byId("limitPriceTypeLastTrade").set("disabled", true);
    // dijit.byId("limitPriceTypeBid").set("disabled", true);
    // dijit.byId("limitPriceTypeAsk").set("disabled", true);
    // dijit.byId("limitPriceTypeMidpoint").set("disabled", true);

    // dijit.byId("limitPriceTypeNone").attr("checked", true); // todo: implement if needed for new design
    self.priceTypeVisible = false;
  } else if (orderType == "STOPLIMIT") {
    let queryValue = "STOP";

    if (item.securityType === "OPTION" || self.optionRecordsPresent) { //Defect #148469
      queryValue = "ISOPTION";
    }

    self.expTypes = getExpTypesByOrderType(queryValue);

    self.priceVisible = false;
    if (item.showAllOrderTypeSelections) {
      //IREBALUX-1213 - Edit Multiple Orders - Allow Stop and Stop Limit Order Types if Same Symbol and Tran Type
      self.limitPriceDisabled = false;
      self.stopPriceDisabled = false;
    }
    if (expirationBoolean) {
      self.limitPrice = self.data.ordLimitPrice; if (!self.limitPrice) {self.limitPrice = self.data.price; }
      self.stopPrice = self.data.ordStopPrice;
    }

    self.limitPriceVisible = true;
    self.stopPriceVisible = true;
    self.expirationTypeDisabled = true;
    //IREBALUX-1857 //sa - disables radios
    // dijit.byId("limitPriceTypeNone").set("disabled", true);
    // dijit.byId("limitPriceTypeLastTrade").set("disabled", true);
    // dijit.byId("limitPriceTypeBid").set("disabled", true);
    // dijit.byId("limitPriceTypeAsk").set("disabled", true);
    // dijit.byId("limitPriceTypeMidpoint").set("disabled", true);

    // dijit.byId("limitPriceTypeNone").attr("checked", true); //todo: implement if needed for new design
    self.priceTypeVisible = false;

    //dojo.byId("limitInstructionText").style.display = "none";
    self.limitInstructionTextVisible = false;
  } else {
    if (orderType == "STOP") {
      let queryValue = "STOP";

      if (item.securityType === "OPTION" || self.optionRecordsPresent) { //Defect #148469
        queryValue = "ISOPTION";
      }

      // dijit.byId('expirationType').query = {
      //   orderType: queryValue
      // };
      self.expTypes = getExpTypesByOrderType(queryValue);
      self.expirationTypeDisabled = true;

      //IREBALUX-354 changes
      if (self.actionType == "MultiEdit" && !item.showAllOrderTypeSelections) { //IREBALUX-1213 - Edit Multiple Orders - Allow Stop and Stop Limit Order Types if Same Symbol and Tran Type
        if (self.isOrderTypePlaceHolder) {
          self.priceDisabled = false; // sa: not testable here, overwritten at the bottom
          self.limitPriceDisabled = false; // sa: not testable here, overwritten  at the bottom
          self.stopPriceDisabled = false; // sa: not testable here, overwritten  at the bottom
        } else {
          self.priceDisabled = true;
          self.limitPriceDisabled = true;
          self.stopPriceDisabled = true;
        }
      } else {
        self.priceDisabled = false;
      }
    } else if (orderType == "LIMIT") {
      let queryValue = checkBlockDeskBool ? "lBLOCKDESK" : "LIMIT";

      if (item.securityType === "OPTION" || self.optionRecordsPresent) { //Defect #148469
        queryValue = "ISOPTION";
      }

      self.optionOrderTypeVisible = item.securityType === "OPTION" && item.optionStrategyType === "SPREAD";
      self.optionOrderTypeDisabled = false;

      self.expTypes = getExpTypesByOrderType(queryValue);
      self.expirationTypeDisabled = false;
      self.expirationDateDisabled = false;

      if (self.priceType != "None") {
        self.priceDisabled = true;
      } else {
        self.priceDisabled = false;
      }

      self.priceTypeVisible = (item.securityType === "OPTION" && item.optionStrategyType === "SPREAD") ? false : true;

      if (expirationBoolean) {
        // dijit.byId("limitPriceTypeNone").attr("checked", true); //todo: implement if needed for new design
        self.priceDisabled = false;
        self.price = null;
        self.pfs.updateOrderPayload.data.price = null;
      }
      self.limitInstructionTextVisible = true;

    } else if (orderType == "TRAILING_STOP_PRC" || orderType == "TRAILING_STOP_DOLLAR") {
      //IREBALUX-1338 - Trailing Stop Orders - In-Line Edit - Add Trailing Stop Order Type to Trade Instructions Modal
      // dijit.byId('expirationType').query = {
      //   orderType: "*STOP*"
      // };
      self.expTypes = getExpTypesByOrderType('STOP');
      self.priceDisabled = false;
      self.price = null;
      self.pfs.updateOrderPayload.data.price = null;
    }
    if (expirationBoolean) {
      //dijit.byId("price").reset();
      self.price = null;
      self.pfs.updateOrderPayload.data.price = null;
    }
    //IREBALUX-354 changes
    if (self.actionType == "MultiEdit" && orderType != "") {
      self.priceDisabled = false;
    }
    self.priceVisible = true;
    self.limitPriceVisible = false;
    self.stopPriceVisible = false;

  }

  //IREBALUX-1338 - Trailing Stop Orders - In-Line Edit - Add Trailing Stop Order Type to Trade Instructions Modal
  //dojo.byId("priceLabelDym").innerHTML = (orderType == "TRAILING_STOP_PRC" || orderType == "TRAILING_STOP_DOLLAR") ? ((orderType == "TRAILING_STOP_PRC") ? "Stop %" : "Stop $") : "Price";
  self.priceLabel = (orderType == "TRAILING_STOP_PRC" || orderType == "TRAILING_STOP_DOLLAR") ? ((orderType == "TRAILING_STOP_PRC") ? "Stop %" : "Stop $") : "Price";
  if (orderType == "TRAILING_STOP_PRC") {
    self.priceConstraints = {
      min: 0,
      max: 99,
      pattern: '##',
      places: '0'
    }
  } else {
    self.priceConstraints = {
      min: 0,
      max: 1000000000,
      pattern: '######.00',
      places: '2'
    }
  }

  self.priceInvalidMessage = (orderType == "TRAILING_STOP_PRC") ? self.priceInvalidMessageTrailingStopPRC : self.priceInvalidMessageOther;
  self.priceRangeMessage = (orderType == "TRAILING_STOP_PRC") ? self.priceRangeMessageTrailingStopPRC : self.priceRangeMessageOther;

  if (orderType == "LIMIT" || orderType == "STOP" || orderType == "STOPLIMIT") {

    if (ordIsNotHeld) {

      if (notHeldDestination == "CITADEL" || notHeldDestination == "VIRTU") {

        //dijit.byId("expirationDate").setDisplayedValue("n/a");
        self.expirationDateDisabled = true;
        self.expirationDate = null;
        if (self.data.variousFields && self.data.variousFields.indexOf('expirationType') > -1) {
          self.expTypeSelected = null;
          self.expirationType = null;
        } else {
          if (self.expirationType) {
            setPreferredExpirationType(self.expTypes, 'DAY');
          }
        }
        self.expirationTypeDisabled = true;

      } else if (notHeldDestination == "AOM_PRINTER") {

        self.expirationTypeDisabled = false;
      }

    } else {
      // if (dijit.byId("expirationDate").getDisplayedValue() == "n/a") { // todo: implement if needed
      //   dijit.byId("expirationDate").setDisplayedValue("");
      // }
      self.expirationDateDisabled = false;
      self.expirationTypeDisabled = false;
    }

    // if (dijit.byId("price").getDisplayedValue() == "M") { //todo: implement if needed
    //   dijit.byId("price").set("value", null);
    // }
    if (self.orderType === 'MARKET') {
      self.price = null;
      self.pfs.updateOrderPayload.data.price = null;
    }

  }

  if (checkBlockDeskBool) {
    // dijit.byId('orderType').query = {
    //   destType: getDestinationQ()
    // }; //IREBALUX-1507 - Prevent Limit Orders when Destination is Set to Block Desk
    // if (self.notHeldDestinationSelected &&  self.notHeldDestinationSelected.id) {
    //   destination = self.notHeldDestinationSelected.id;
    // }
    self.setDestination();

  }
  if (self.expTypeSelected) {
    self.expirationDateToggle(self.expTypeSelected.id, item);
  }

  //IREBALUX-354 changes
  if (self.actionType == "MultiEdit" && (orderType == "STOP" || orderType == "STOPLIMIT") && !item.showAllOrderTypeSelections) { //IREBALUX-1213 - Edit Multiple Orders - Allow Stop and Stop Limit Order Types if Same Symbol and Tran Type
    self.expirationDateDisabled = true;
    self.expirationTypeDisabled = true;
    if (!self.sameSymbol) {
      self.priceDisabled = true;
      self.limitPriceDisabled = true;
      self.stopPriceDisabled = true;
    }
  }
  const expType = self.expTypeSelected ? self.expTypeSelected.id : '';
  //IREBALUX-354 changes
  if (self.actionType == "MultiEdit" && orderType == "LIMIT") {

    if (expType == "GTD" || expType == "GTDEXT") {
      self.expirationDateDisabled = false;
    } else {
      let gtdOrGTDExtFiltered = [];
      for (let i = 0; i < self.multiRecords.length; i++) {
        const item = self.multiRecords[i];
        let expirationType = item.expirationType;
        if (!expirationType) {expirationType = ''};
        if (expirationType.toLowerCase().startsWith('gtd') ) {
          gtdOrGTDExtFiltered.push(item);
        }
      }
      if (gtdOrGTDExtFiltered.length === self.multiRecords.length) {
        self.expirationDateDisabled = false;
      } else {
        self.expirationDateDisabled = true;
        self.expirationDate = null;
      }
      //dijit.byId("expirationDate").setDisplayedValue("n/a");
    }
  }
  /* IREBALUX-462 - When editing Multiple Orders that all have the same initial Order Type of Market, the Expiration type field should not be disabled upon launching the modal.
   * This field should be enabled, allowing the user to specify either "Day" or "MoC" (existing functionality).
   *
   * @param !item.optionRecordsPresent - Defect #149046 - MOC orders are not allowed for option securities
   * - When editing multiple orders on the order blotter and an option is selected it allows MOC as an expiration type for a market order.
   *   The only expiration type allowed for an option market order is Day.
   *   The MOC condition must be removed when editing multiple option or editing multiple equities combined with option orders.
   */
  if (self.actionType == "MultiEdit" && orderType == "MARKET" && !self.optionRecordsPresent) { //#149046
    self.expirationTypeDisabled = false;
  }

  if (self.actionType == "MultiEdit") {

    /**Order type dropdown field should only have 2 options available: Market or Limit. As part of the MVP,
     * we will not allow users to add Stop or Stop Limit order type instructions when editing multiple orders.
     */
    // dijit.byId('orderType').query = {
    //   destType: getDestinationQ()
    // }; //IREBALUX-1507 - Prevent Limit Orders when Destination is Set to Block Desk
    // if (self.notHeldDestinationSelected &&  self.notHeldDestinationSelected.id) {
    //   destination = self.notHeldDestinationSelected.id;
    // }
    self.setDestination();
  } else {
    //self.destinationInstructionText = '';
  }

  if (orderType == "LIMIT") { // QC#Defect #150845
    self.limitInstructionTextVisible = true;
  } else {
    self.limitInstructionTextVisible = false;
  }
  /*
   * IREBALOPNS-1843
   * Create and Edit Trade Instructions modal for Spread orders
   */
  self.spreadOptionAction((orderType == "LIMIT" || orderType == "MARKET") ? "setValues" : "");


}
